export class ChartJsData {
    labels: string[] = [];
    datasets: ChartJsDataset[] = [];
}

export class ChartJsDataset {
    label: string = "";
    data: number[] = [];
    backgroundColor?: string = "blue";
    borderColor?: string = "black";
    borderWidth?: number = 10;
    pointStyle?: string = undefined;
    pointRadius?: number = 10;
    pointHoverRadius?: number = 10;
    tension?: number = 0.4;
    fill?: ChartJsDatasetFill;
}

export class ChartJsDatasetFill {
    target: string = "origin";
    above: string = "rgba(48, 140, 207, 0.05)";
    below: string = "rgba(233, 30, 30, 0.05)";
}
